import type { ReactNode } from 'react';
import { Icon } from '../components/Icon';
import { useUI } from '../state/ui';

/** Barra de ferramentas + área de conteúdo de uma seção. */
export function Page({ toolbar, children }: { toolbar: ReactNode; children: ReactNode }) {
  return (
    <>
      <header className="toolbar"><SidebarToggle />{toolbar}</header>
      <div className="content">{children}</div>
    </>
  );
}

function SidebarToggle() {
  const set = useUI(s => s.set);
  const toggle = () => {
    const s = useUI.getState();
    if (matchMedia('(max-width:860px)').matches) set({ sidebarOpen: !s.sidebarOpen });
    else set({ sidebarHidden: !s.sidebarHidden });
  };
  return <button className="tb-btn" onClick={toggle} aria-label="Mostrar ou ocultar barra lateral"><Icon name="side" /></button>;
}
